module.exports = __webpack_public_path__ + "static/media/reply-icon.5010d2d1.svg";